'use strict';

import { setCookie, getCookie } from '../common/cookie';

import formValidation from '../components/formValidation';

function getHeaderHeight() {
    var topSpacerHeight = $('.cc-header-top-spacer').outerHeight() || 0;
    var wrappersHeight = 0;

    $('.cc-header-wrp').each(function () {
        wrappersHeight += $(this).outerHeight() || 0;
    });

    return topSpacerHeight + wrappersHeight;
}

function getToastHeaderGap() {
    if (window.isDesktop) {
        return 52;
    }
    else {
        return 16;
    }
}

function scrollToTop() {
    $('html, body').animate({ scrollTop: 0 }, 500);
}

//Handle AJAX response globally
function handleResponse($response) {
    const $errorToast = $('.js-errorToast');
    const $successToast = $('.js-successToast');
    var $finalToast = null;

    if ($('body').hasClass('modal-open')) {
        $('body').find('.cc-modal.show').modal('hide');
    }

    if ($response === 'success') {
        $finalToast = $successToast;
        $finalToast.find('.cc-toast__text').text($finalToast.find('.cc-toast__text').data('newsletter-text'));
    } else {
        $finalToast = $errorToast;
    }

    // Position toast below header
    $finalToast.css('top', (getHeaderHeight() + getToastHeaderGap()) + 'px');

    $finalToast.removeClass('d-none').addClass('show');

    scrollToTop();

    setTimeout(function () {
        $finalToast.removeClass('show').addClass('d-none');
    }, 2500);

    setTimeout(function () {
        window.location.reload();
    }, 3000);
    $.spinner().stop();
}

$(document).on('submit', '#newsletterSubmit', function (e) {
    e.preventDefault();
    var $form = $(this);
    var url = $form.attr('action');
    var siteKey = $('meta[name="g-recaptcha"]').attr('content');
    var action = 'newsletter_subscribe';
    var isRecaptchaEnabled = $('meta[name="is-recaptcha-enabled"]').attr('content') === 'true';

    if (!isRecaptchaEnabled) {
        $('.js-submitNewsletter').prop('disabled', true);
        $.ajax({
            url: url,
            type: 'POST',
            data: $form.serialize(),
            success: function (data) {
                $('.js-submitNewsletter').prop('disabled', false);

                if (!data.success) {
                    formValidation($form, data);
                    handleResponse('error');
                } else {
                    handleResponse('success');
                    window.datalayer = data.datalayer;
                }
            },
            error: function () {
                $('.js-submitNewsletter').prop('disabled', false);
                handleResponse('error');
            }
        });
        return;
    }

    grecaptcha.ready(function () {
        grecaptcha.execute(siteKey, { action: action }).then(function (token) {
            var $tokenInput = $form.find('input[name="g-recaptcha-response"]');
            if ($tokenInput.val(token)) {
                $.ajax({
                    url: url,
                    type: 'POST',
                    data: $form.serialize(),
                    success: function (data) {
                        $('.js-submitNewsletter').prop('disabled', false);

                        if (!data.success) {
                            formValidation($form, data);
                            handleResponse('error');
                        } else {
                            handleResponse('success');
                            if (data.datalayer) {
                                window.datalayer = data.datalayer;
                            }
                        }
                    },
                    error: function () {
                        $('.js-submitNewsletter').prop('disabled', false);
                        handleResponse('error');
                    }
                });
            } else {
                console.error('auth failed');
                return false;
            }
        });
    });
});

//Handle newsletter modal display
$(() => {
    const isDismissed = getCookie('newsletter');
    const newsletterModal = '#newsletterModal';
    const isRegistered = newsletterModal && $(newsletterModal).data('registered') ? true : false;
    // customizable expiration for 'newsletter' cookie via site preference
    const expiration = newsletterModal && $(newsletterModal).data('expiration') ? $(newsletterModal).data('expiration') * 24 : 0;

    if (!isDismissed && !isRegistered) {
        if ($(newsletterModal).length && typeof $(newsletterModal).modal === 'function') {
 
            $(newsletterModal).modal('show');

            $('.js-newsletterModalClose').on('click', function () {
                setCookie('newsletter', true, expiration);
                $(newsletterModal).modal('hide');

                $(document).trigger('newsletterDismissed');
            });
        }

        $(newsletterModal).on('click', function (e) {
            if (e.target === this) {
                setCookie('newsletter', true, expiration);
                $(newsletterModal).modal('hide');
                $(document).trigger('newsletterDismissed');
            }
        });

        $(document).on('keydown', function (e) {
            if (e.key === 'Escape') {
                setCookie('newsletter', true, expiration);
                $(newsletterModal).modal('hide');
                $(document).trigger('newsletterDismissed');
            }
        });
    } else if ($(newsletterModal).length && typeof $(newsletterModal).modal === 'function') {
        $(newsletterModal).modal('hide');
        $(document).trigger('newsletterDismissed');
    }
});